module.exports = __webpack_public_path__ + "static/img/konggangmoniqi.5775e37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/konggangmoniqi.png
// module id = TOgg
// module chunks = 1